var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 20,
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 5.5,
  width: 12,
  height: 14,
  rx: 1.5,
  stroke: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 4.5V3C5 1.89543 5.89543 1 7 1H15C16.1046 1 17 1.89543 17 3V12.5C17 13.6046 16.1046 14.5 15 14.5H13.5",
  stroke: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };